import React from "react";
import { Reveal } from "../components/Reveal";
import { PageHero, CtaBand, SectionHead } from "../components/UI";
import {
  IconShield,
  IconLock,
  IconServer,
  IconFingerprint,
  IconSearch,
  IconUsers,
  IconCheck,
  IconGlobe,
} from "../components/Icons";

export function Security() {
  return (
    <>
      <PageHero
        eyebrow="Bảo mật & hạ tầng"
        title="Dữ liệu cuộc họp được kiểm soát chặt từ thu nhận đến lưu trữ"
        sub="Phân quyền theo vai trò, nhật ký kiểm toán đầy đủ, và lựa chọn triển khai trong hạ tầng nội bộ của đơn vị."
      />

      <section className="section">
        <div className="container">
          <div className="grid cards-3">
            {[
              [<IconUsers size={24} />, "", "Phân quyền theo vai trò", "Người dùng thường chỉ thấy và thao tác trên cuộc họp của mình; quản trị viên quản lý toàn bộ và xem nhật ký."],
              [<IconSearch size={24} />, "teal", "Nhật ký kiểm toán", "Ghi nhận các thao tác xem, chỉnh sửa, tải xuống và xoá dữ liệu để phục vụ tra cứu, kiểm tra."],
              [<IconServer size={24} />, "violet", "Triển khai nội bộ", "Có thể chạy trong hạ tầng của đơn vị, giữ dữ liệu họp trong phạm vi kiểm soát của tổ chức."],
              [<IconLock size={24} />, "amber", "Khoá tích hợp được giấu kín", "Toàn bộ khoá và dịch vụ bên thứ ba xử lý ở phía máy chủ — không lộ ra trình duyệt người dùng."],
              [<IconFingerprint size={24} />, "", "Đăng nhập tập trung (SSO)", "Hỗ trợ đăng nhập bằng tài khoản tập trung của đơn vị, thuận tiện cho quản trị người dùng."],
              [<IconShield size={24} />, "teal", "Lưu trữ có kiểm soát", "Bản ghi và biên bản được lưu tập trung, gắn với người tạo và phạm vi truy cập rõ ràng."],
            ].map(([ic, cls, h, p], i) => (
              <Reveal key={i} className="card" delay={(i % 3) * 70}>
                <div className={`ic ${cls as string}`}>{ic as React.ReactNode}</div>
                <h3>{h as string}</h3>
                <p>{p as string}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section soft">
        <div className="container split">
          <Reveal>
            <span className="eyebrow">Kiến trúc xử lý</span>
            <h2>Mọi nghiệp vụ nằm ở backend — trình duyệt chỉ là cửa sổ hiển thị</h2>
            <p>
              Phiên âm thời gian thực, tóm tắt và sinh báo cáo đều được điều phối ở phía máy chủ.
              Trình duyệt người dùng chỉ gửi âm thanh và nhận kết quả, không bao giờ giữ khoá hay
              gọi thẳng dịch vụ bên ngoài.
            </p>
            <div className="ticks">
              {[
                "Khoá API và endpoint bên thứ ba chỉ tồn tại trên máy chủ",
                "Kết nối phiên âm trực tiếp đi qua lớp trung gian của hệ thống",
                "Tách bạch rõ vai trò người dùng và quản trị",
                "Dữ liệu nhạy cảm không nằm trong mã nguồn phía trình duyệt",
              ].map((t, i) => (
                <div className="tick" key={i}>
                  <span className="ck">
                    <IconCheck size={15} />
                  </span>
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={120} className="visual">
            <div className="mock-row" style={{ alignItems: "center" }}>
              <div className="avatar" style={{ background: "#3b4ef0" }}>
                <IconGlobe size={18} />
              </div>
              <div>
                <div className="who">Trình duyệt</div>
                <div className="tx">Gửi âm thanh · nhận văn bản</div>
              </div>
            </div>
            <div style={{ textAlign: "center", color: "#9aa6c8", fontSize: 20, margin: "2px 0" }}>↓</div>
            <div className="mock-row" style={{ alignItems: "center", borderColor: "var(--brand)" }}>
              <div className="avatar" style={{ background: "#14c8a8" }}>
                <IconServer size={18} />
              </div>
              <div>
                <div className="who">Backend Ghi Âm Pro</div>
                <div className="tx">Giữ khoá · điều phối phiên âm · phân quyền</div>
              </div>
            </div>
            <div style={{ textAlign: "center", color: "#9aa6c8", fontSize: 20, margin: "2px 0" }}>↓</div>
            <div className="mock-row" style={{ alignItems: "center" }}>
              <div className="avatar" style={{ background: "#6a3df0" }}>
                <IconLock size={18} />
              </div>
              <div>
                <div className="who">Dịch vụ xử lý</div>
                <div className="tx">Chỉ máy chủ truy cập, ẩn với người dùng</div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBand
        title="Cần triển khai trong hạ tầng nội bộ?"
        sub="Trao đổi yêu cầu bảo mật và môi trường của đơn vị, chúng tôi sẽ tư vấn phương án triển khai phù hợp."
      />
    </>
  );
}
